import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_consolidated_arap_applet_catalog_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    consolidated_arap_hdr_guid: fromDatatype.GuidDataFieldInterface;
    applet_catalog_guid: fromDatatype.GuidDataFieldInterface;
    rank: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;

}

export class bl_fi_consolidated_arap_applet_catalog_link_RowClass implements bl_fi_consolidated_arap_applet_catalog_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    consolidated_arap_hdr_guid: fromDatatype.GuidDataFieldInterface;
    applet_catalog_guid: fromDatatype.GuidDataFieldInterface;
    rank: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}